<script setup>
import {onBeforeMount, onMounted, ref} from 'vue';
import axios from 'axios';
import NewRequest from "@/components/modals/NewRequestModal.vue";
import router from "@/router";
import store from "@/store/store";
import {format} from 'date-fns';
import Multiselect from "vue-multiselect";
import { Tooltip } from 'bootstrap';

import EditRequestManagerSideModal from "@/components/modals/EditRequestManagerSideModal.vue";
import EditRequestFitterSideModal from "@/components/modals/EditRequestFitterSideModal.vue";

let requests = ref([]);
let temp_requests = ref([]);

let is_fitter = ref(false);
let is_manager = ref(false);
let is_engineer = ref(false);
let is_superuser = ref(false);

// filter fields
let request_statuses = ref([]);
let request_statuses_list_show_edit = ref(['1', "2", "3", '12', '4', '6'])
let fitters_list = ref([]);
// let engineers_list = ref([]);
let managers_list = ref([]);
let areas_streets_array = ref(null);
let request_kinds_types_array = ref(null);
let houses = ref([]);

const loading_page = ref(false);
const loading_search = ref(false);

const error = ref(null);

// Pagination state
const next = ref(null);
const previous = ref(null);
const count = ref(0);

const temp_next = ref(null);
const temp_previous = ref(null);
const temp_count = ref(0);

const currentPage = ref(1);
const page_size = ref(15);

const is_filter_on = ref(false);

const formData = ref({
  selected_status: '',
  selected_fitter: '',
  // selected_engineer: '',
  selected_manager: '',
  selected_request_type: {
    type_id: '',
    type_name: ''
  },
  selected_request_kind: {
    kind_id: '',
    kind_name: '',
  },
  selected_area: '',
  selected_street: {
    street_id: ''
  },
  selected_house: {
    house_id: ''
  },
  selected_request_date_start: '',
  selected_request_date_end: '',
});

const search_text = ref('');
const is_search_activated = ref(false)

let requests_date_start = ref('');
let requests_date_end = ref('');

async function fetchNewRequests(limit = 15, offset = 0) {
  try {
    loading_page.value = true;
    if (search_text.value === '') {
      const response = await axios.get(`all_requests_by_client/?limit=${limit}&offset=${offset}`);

      const requests_data = response.data.results;
      if (requests_data) {
        requests.value = requests_data.map(request => ({
          request_id: request.id,
          username: request.username,
          client_name: request.client_name,
          area: request.area,
          street: request.street,
          house: request.house,
          flat: request.flat,
          client_address: request.client_address,
          request_address: request.request_address,
          request_status_id: request.request_status_id,
          request_status_name: request.request_status_name,
          request_type: request.request_type,
          request_kind: request.request_kind,
          manager_id: request.manager_id,
          manager_name: request.manager_name,
          manager_comment: request.manager_comment,
          fitter_id: request.fitter_id,
          fitter_name: request.fitter_name,
          fitter_comment: request.fitter_comment,
          date_created: request.date_created,
          date_expire8: request.date_expire8,
          date_expire48: request.date_expire48,
          date_closed: request.date_closed,
          is_repeated: request.is_repeated,
        }));
        temp_requests.value = requests.value;
        // console.log(temp_requests.value);
        // console.log("fetch data: "+JSON.stringify(temp_requests.value, null, 2));
      } else {
        console.error('Error in the API response.');
      }

      next.value = response.data.next;
      temp_next.value = next.value;
      previous.value = response.data.previous;
      temp_previous.value = previous.value;
      count.value = response.data.count;
      temp_count.value = count.value;
    } else {
      await search();
    }

  } catch (err) {
    error.value = err;
    console.error('Error fetching requests:', err);
  } finally {
    loading_page.value = false;
  }
}

const fetchFilterFields = async () => {
  // Fetching various lists

  request_kinds_types_array.value = (await axios.get('request_types_with_kinds/')).data;

  request_kinds_types_array.value.unshift({
    type_id: '',
    type_name: '',
    kinds: []
  });

  const lists_res = (await axios.get('request_related_lists/')).data;
  managers_list = lists_res.request_managers;
  managers_list.unshift({id: '', name: ''});

  // engineers_list = lists_res.request_engineers;
  // engineers_list.unshift({id: '', name: ''});

  fitters_list = lists_res.request_fitters;
  fitters_list.unshift({id: '', name: ''});

  request_statuses = lists_res.request_statuses;
  // request_statuses.unshift({id: '', name: ''});
  areas_streets_array.value = (await axios.get('areas_with_streets_list/')).data;

  areas_streets_array.value.unshift({
    area_id: '',
    area_name: '',
    streets: [] // streets is an array
  });
};
const fetchHousesByStreet = async (id) => {
  houses.value = (await axios.get(`houses_by_streets/`, {
    params: {
      street_id: id,
    }
  })).data;
}

async function requestFilter(limit = 15, offset = 0) {
  try {
    loading_page.value = true;
    const params = {
      limit,
      offset,
    };

    if (formData.value.selected_manager)
      params.manager_id = formData.value.selected_manager;

    if (formData.value.selected_fitter)
      params.fitter_id = formData.value.selected_fitter;

    if (formData.value.selected_status && formData.value.selected_status.length > 0)
      params.request_statuses = JSON.stringify(formData.value.selected_status);

    if (formData.value.selected_request_type?.type_id)
      params.request_type_id = JSON.stringify([formData.value.selected_request_type.type_id]);

    if (formData.value.selected_request_kind?.kind_id)
      params.request_kind_id = formData.value.selected_request_kind.kind_id;

    if (formData.value.selected_area?.area_id)
      params.area_id = formData.value.selected_area.area_id;

    if (formData.value.selected_street?.street_id)
      params.street_id = formData.value.selected_street.street_id;

    if (formData.value.selected_house?.house_id)
      params.house_id = formData.value.selected_house.house_id;

    if (formData.value.selected_request_date_start)
      params.date_start = formData.value.selected_request_date_start;

    if (formData.value.selected_request_date_end)
      params.date_end = formData.value.selected_request_date_end;

    const res = await axios.get(`requests_filter/`, { params });

    // console.log(formData.value.selected_status);
    temp_requests.value = res.data.results.map(request => ({
      request_id: request.id,
      username: request.username,
      client_name: request.client_name,
      area: request.area,
      street: request.street,
      house: request.house,
      flat: request.flat,
      client_address: request.client_address,
      request_address: request.request_address,
      request_status_id: request.request_status_id,
      request_status_name: request.request_status_name,
      request_type: request.request_type,
      request_kind: request.request_kind,
      manager_id: request.manager_id,
      manager_name: request.manager_name,
      manager_comment: request.manager_comment,
      fitter_id: request.fitter_id,
      fitter_name: request.fitter_name,
      fitter_comment: request.fitter_comment,
      date_created: request.date_created,
      date_expire8: request.date_expire8,
      date_expire48: request.date_expire48,
      date_closed: request.date_closed,
      is_repeated: request.is_repeated,
    }));
    temp_next.value = res.data.next
    temp_previous.value = res.data.previous;
    temp_count.value = res.data.count;
    if (!is_filter_on.value) {
      currentPage.value = 1;
      is_filter_on.value = true;
    }
  } catch (err) {
    console.error('Error filtering clients:', err);
  } finally {
    loading_page.value = false;
  }
}

function resetResults() {
  is_filter_on.value = false;
  search_text.value = '';
  is_search_activated.value = false;
  temp_requests.value = requests.value
  page_size.value = "15"
  formData.value = {
    selected_status: '',
    selected_fitter: '',
    // selected_engineer: '',
    selected_manager: '',
    selected_request_type: {
      type_id: '',
      type_name: ''
    },
    selected_request_kind: {
      kind_id: '',
      kind_name: '',
    },
    selected_area: '',
    selected_street: {
      street_id: ''
    },
    selected_house: {
      house_id: ''
    },
    selected_request_date_start: requests_date_start.value,
    selected_request_date_end: requests_date_end.value,
  };

  temp_next.value = next.value;
  temp_previous.value = previous.value;
  temp_count.value = count.value;
  currentPage.value = 1;
}

async function search(limit = 15, offset = 0) {
  try {
    if (search_text.value === '') {
      console.log("nothing to search")
      return;
    }
    else if (search_text.value.length <= 2) {
      page_size.value = "15";
      temp_requests.value = requests.value;
      temp_next.value = next.value;
      temp_previous.value = previous.value;
      temp_count.value = count.value;
      return;
    }
    loading_search.value = true;
    currentPage.value = 1;
    is_search_activated.value = true;
    const res = await axios.get(`search_requests/?limit=${limit}&offset=${offset}`, {
      params: {
        q: search_text.value
      }
    });

    if (res.data.results) {
      // requests.value = searchResults;
      temp_requests.value = res.data.results.map(request => ({
        request_id: request.id,
        username: request.username,
        client_name: request.client_name,
        area: request.area,
        street: request.street,
        house: request.house,
        flat: request.flat,
        client_address: request.client_address,
        request_address: request.request_address,
        request_status_id: request.request_status_id,
        request_status_name: request.request_status_name,
        request_type: request.request_type,
        request_kind: request.request_kind,
        manager_id: request.manager_id,
        manager_name: request.manager_name,
        manager_comment: request.manager_comment,
        fitter_id: request.fitter_id,
        fitter_name: request.fitter_name,
        fitter_comment: request.fitter_comment,
        date_created: request.date_created,
        date_expire8: request.date_expire8,
        date_expire48: request.date_expire48,
        date_closed: request.date_closed,
        is_repeated: request.is_repeated,
      }));
    } else {
      temp_requests.value = []; // Clear the table if no results
    }
    temp_next.value = res.data.next;
    temp_previous.value = res.data.previous;
    temp_count.value = res.data.count;
  } catch (e) {
    console.error(e.toString());
  } finally {
    loading_search.value = false;
  }
}

//-----------------redirection to details of specific request
const goToRequestDetails = (request_id) => {
  // console.log("request_id"+request_id)
  // router.push({
  //   name: 'request details',
  //   query: {request_id}
  // });
  const routerData = router.resolve(
      {
        name: 'request details',
        query: {request_id: request_id}
      });

  window.open(routerData.href, '_blank');
};

function requestTableStatusColor(status, date_expire) {
  const current_date = new Date();
  const expire_date = new Date(date_expire);

  if (
      current_date > expire_date &&
      ((status !== "12") &&
          (status !== "13") &&
          (status !== "5") &&
          (status !== "14"))
  )
  {
    // console.log(current_date > expire_date && (status !== 'Выполнен монтёром' || status !== 'Выполнено'))
    return 'table-red';
  }

  switch (status) {
    case '13':
      return 'table-green';
    case '12':
      return 'table-blue'
    case '5' : case '14': case '16': case '17':
      return 'table-yellow'
    case '8':
    case '9':
      return 'table-red'
    default:
      return 'table-white'
  }
}

const exportToCSV = () => {
  // Define the CSV headers
  const headers = [
    '\"Менеджер\"',
    '\"Дата\"',
    '\"Абонент\"',
    '\"Адрес\"',
    '\"Участок\"',
    '\"Причина\"',
    '\"Статус\"',
    '\"Комментарий менеджера\"',
    '\"Монтер\"',
    '\"Комментарий монтера\"',
  ];

  // Function to escape double quotes and handle newlines
  const escapeCSVField = (field) => {
    if (field === null || field === undefined) {
      return ""; // Return empty string for null/undefined
    }
    // Convert the field to a string
    let escapedField = field.toString();
    // Replace double quotes with two double quotes (CSV escaping)
    escapedField = escapedField.replace(/"/g, '""');
    // Replace newlines with a space (or another delimiter if needed)
    escapedField = escapedField.replace(/\n/g, " ");
    return escapedField;
  };

  // Extract table data and handle null values
  const rows = temp_requests.value.map((request) => [
    `"${escapeCSVField(request.manager_name)}"`, // Wrap in double quotes
    `"${escapeCSVField(formattedTimestamp(request.date_created))}"`,
    `"${escapeCSVField(request.client_name)}"`,
    `"${escapeCSVField(`${request.street} ${request.house} ${request.flat}`)}"`,
    `"${escapeCSVField(request.area)}"`,
    `"${escapeCSVField(request.request_kind)}"`,
    `"${escapeCSVField(request.request_status_name)}"`,
    `"${escapeCSVField(request.manager_comment)}"`,
    `"${escapeCSVField(request.fitter_name)}"`,
    `"${escapeCSVField(request.fitter_comment)}"`,
  ]);

  // Combine headers and rows
  const csvContent = [headers, ...rows]
      .map((row) => row.join(",")) // Join cells with commas
      .join("\n");

  // Add UTF-8 BOM at the beginning of the file
  const BOM = "\uFEFF";
  const blob = new Blob([BOM + csvContent], { type: "text/csv;charset=utf-8;" });

  // Create a download link and trigger the download
  const link = document.createElement("a");
  const url = URL.createObjectURL(blob);
  const fileName = "requests_" + formattedTimestamp(new Date()) + ".csv";

  link.setAttribute("href", url);
  link.setAttribute("download", fileName);
  link.style.visibility = "hidden";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

const goToNextPage = () => {
  if (temp_next.value) {
    currentPage.value++;
    refreshRequests()
  }
}

const goToPreviousPage = () => {
  if (temp_previous.value) {
    currentPage.value--;
    refreshRequests()
  }
}
const formattedTimestamp = (datetime) => {
  if (!datetime) return ''; // Return empty string if no datetime

  // Try parsing the date
  try {
    const date = new Date(datetime);

    // Check if the date is valid
    if (isNaN(date.getTime())) {
      return ''; // Return empty string for invalid dates
    }

    return format(date, 'dd/MM/yyyy, HH:mm');
  } catch (error) {
    console.error('Error formatting timestamp:', error);
    return ''; // Return empty string if parsing fails
  }
};

const refreshRequests = () => {
  if (is_filter_on.value) {
    requestFilter(page_size.value, (currentPage.value - 1) * page_size.value)
  } else {
    fetchNewRequests(page_size.value, (currentPage.value - 1) * page_size.value);
  }
}

onMounted(() => {
  fetchNewRequests(page_size.value, (currentPage.value - 1) * page_size.value);
  fetchFilterFields();
  const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
  [...tooltipTriggerList].map(
      (tooltipTriggerEl) => new Tooltip(tooltipTriggerEl)
  );
});

onBeforeMount(() => {
  is_manager = store.getters['profile/is_manager']
  is_fitter = store.getters['profile/is_fitter']
  is_engineer = store.getters['profile/is_engineer']
  // console.log(is_engineer)
  is_superuser = store.getters['profile/is_superuser']
})
</script>

<template>
  <div class="content-wrapper">
    <div class="mt-5 pt-3 mx-2 mx-sm-2">
      <div class="row g-2 mb-2 d-flex justify-content-start align-items-center">
        <!-- Left Side: New Request and Dropdown -->
        <div class="col-5 col-md-4 col-lg-3 d-flex justify-content-start align-items-center">
          <!-- New Request Component -->
          <new-request
              :request_statuses="request_statuses"
              :fitters_list="fitters_list"
              :managers_list="managers_list"
              :areas_streets_array="areas_streets_array"
              :request_kinds_types_array="request_kinds_types_array"
              @refresh-requests="refreshRequests"
              data-bs-toggle="tooltip"
              data-bs-placement="bottom"
              data-bs-title="Создать заявку"
          ></new-request>

          <!-- Dropdown Button -->
          <div class="dropdown ms-2">
            <button
                class="btn btn-sm btn-outline-secondary dropdown-toggle"
                type="button"
                id="dropdownMenuButton"
                data-bs-toggle="dropdown"
                aria-expanded="false"
            >
              <i class="bi bi-funnel me-1"></i>Фильтры
            </button>
            <!-- Dropdown Menu -->
            <div class="dropdown-menu filter-menu p-3" aria-labelledby="dropdownMenuButton">
              <!-- Form Content -->
              <div class="row g-3">
                <!-- Form Selects grouped in 3 on larger screens -->
                <div class="col-12 col-md-4">
                  <label class="form-label">Менеджер:</label>
                  <select class="form-select" v-model="formData.selected_manager">
                    <option
                        v-for="manager in managers_list"
                        :value="manager.manager_user_id"
                    >
                      {{ manager.manager_name }}
                    </option>
                  </select>
                </div>
                <div class="col-12 col-md-4" v-if="is_manager || is_engineer">
                  <label class="form-label">Монтер:</label>
                  <select class="form-select" v-model="formData.selected_fitter">
                    <option
                        v-for="fitter in fitters_list"
                        :value="fitter.fitter_id"
                    >
                      {{ fitter.fitter_name }}
                    </option>
                  </select>
                </div>
                <div class="col-12 col-md-4" @click.stop>
                  <label class="form-label">Статус:</label>
                  <multiselect
                      v-model="formData.selected_status"
                      :options="request_statuses"
                      :multiple="true"
                      label="name"
                      track-by="id"
                      placeholder=""
                      :close-on-select="false"
                  ></multiselect>
                </div>
              </div>
              <div class="row g-3">
                <div class="col-12 col-md-4">
                  <label class="form-label">Участок:</label>
                  <select
                      class="form-select" v-model="formData.selected_area"
                      @change="formData.selected_street.street_id=''; formData.selected_house.house_id=''; formData.selected_house.house_name=''"
                  >
                    <option
                        v-for="area in areas_streets_array"
                        :value="area"
                    >
                      {{ area.area_name }}
                    </option>
                  </select>
                </div>
                <div class="col-12 col-md-4">
                  <label class="form-label">Улица: </label>
                  <select
                      class="form-select"
                      v-model="formData.selected_street"
                      :disabled="formData.selected_area===''"
                      @change="fetchHousesByStreet(formData.selected_street.street_id)"
                  >
                    <option
                        v-for="street in formData.selected_area.streets"
                        :value="street"
                    >
                      {{ street.street_name }}
                    </option>
                  </select>
                </div>
                <div class="col-12 col-md-4">
                  <label class="form-label">Дом: </label>
                  <select
                      class="form-select"
                      v-model="formData.selected_house"
                      :disabled="formData.selected_street.street_id===''"
                  >
                    <option
                        v-for="house in houses"
                        :value="house"
                    >
                      {{house.house_name }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="row g-3">
                <div class="col-12 col-md-4">
                  <label class="form-label">Вид:</label>
                  <select class="form-select" v-model="formData.selected_request_type">
                    <option
                        v-for="type in request_kinds_types_array"
                        :value="type"
                    >
                      {{ type.type_name }}
                    </option>
                  </select>
                </div>
                <div class="col-12 col-md-4">
                  <div>
                    <label class="form-label">Причина:</label>
                    <select class="form-select" v-model="formData.selected_request_kind" :disabled="formData.selected_request_type.type_id===''">
                      <option
                          :disabled="!formData.selected_request_type"
                          v-for="(kind, index) in formData.selected_request_type.kinds"
                          :key="index"
                          :value="kind"
                      >
                        {{ kind.kind_name }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="d-flex mt-3">
                <div class="d-flex flex-wrap">
                  <label class="form-label m-1">От: </label>
                  <input class="form-control m-1" type="date" v-model="formData.selected_request_date_start"/>
                  <label class="form-label m-1">До: </label>
                  <input class="form-control m-1" type="date" v-model="formData.selected_request_date_end"/>
                </div>
              </div>
              <button
                  type="submit"
                  class="btn btn-outline-primary m-1 align-self-center flex-fill"
                  @click.prevent="() => requestFilter(page_size, (currentPage - 1) * page_size)"
              >
                <i class="bi bi-card-list"></i>Показать
              </button>
            </div>
          </div>

          <!-- Reset Button -->
          <div class="col-2">
            <button
                v-if="search_text || is_search_activated || is_filter_on"
                class="btn btn-sm btn-outline-danger"
                @click.prevent="resetResults"
            >
              Сбросить
            </button>
          </div>
        </div>

        <!-- Center: Count and Page Size Selector -->
        <div class="col-6 col-md-5 col-lg-5 d-flex align-items-center justify-content-between justify-content-lg-end">
          <!-- Кол-во -->
          <div class="col-4 col-md-5 col-lg-3 d-flex justify-content-lg-end">
            <p class="fw-semibold mb-0">Кол-во: {{ temp_count }}</p>
          </div>

          <!-- Select Box with Label -->
          <div class="col-8 col-md-7 col-lg-5 d-flex justify-content-lg-end align-items-center">
            <p class="fw-semibold mb-0">Заявок на странице:</p>
            <select
                v-model="page_size"
                id="page_size"
                class="form-select form-select-sm w-auto"
                @change="refreshRequests"
            >
              <option value="15">15</option>
              <option value="30">30</option>
              <option value="100">100</option>
              <option value="500">300</option>
              <option
                  v-if="is_superuser"
                  :value="temp_count"
                  class="bg-warning"
              >
                {{temp_count}}
              </option>
            </select>
          </div>
        </div>

        <!-- Right Side -->
        <div class="col-12 col-lg-4 d-flex align-items-center">
          <div
              class="input-group"
              :class="(is_fitter && !is_superuser)?['col-12']:['col-10 col-lg-11']"
          >
      <span class="input-group-text bg-light">
        <i class="bi bi-search text-muted"></i>
      </span>
            <input
                id="search_abonent"
                type="search"
                class="form-control"
                placeholder="Поиск по абоненту или улице"
                v-model="search_text"
                @input="search"
            >
          </div>
          <div v-if="is_manager || is_engineer" class="col-1 me-2">
            <button
                class="btn btn-sm btn-primary"
                data-bs-toggle="tooltip"
                data-bs-placement="bottom"
                data-bs-title="Экспорт в CSV"
                @click="exportToCSV"
            >
              <i class="bi bi-filetype-csv"></i>
            </button>
          </div>
        </div>
      </div>

    </div>

    <!-- Table section -->
    <div v-if="loading_page" class="spinner-container">
      <div class="spinner-border" role="status">
        <span class="sr-only">Загрузка...</span>
      </div>
    </div>
    <div id="request-table" v-else>
      <div v-if="loading_search" class="spinner">
        <div class="double-bounce1"></div>
        <div class="double-bounce2"></div>
      </div>
      <div v-else style="overflow-x:auto;">
        <table class="table table-bordered">
          <thead>
          <tr>
            <th scope="col" v-if="is_fitter">Ред. заявку</th>
            <th scope="col">Менеджер</th>
            <th scope="col">Дата</th>
            <th scope="col">Абонент</th>
            <th scope="col">Адрес</th>
            <th scope="col">Участок</th>
            <th scope="col">Причина</th>
            <th scope="col">Статус</th>

            <th scope="col">Коментарий менеджера</th>
            <th scope="col">Монтер</th>
            <th scope="col">Коментарий монтера</th>
            <th scope="col" v-if="is_manager ">Ред. заявку</th>
          </tr>
          </thead>
          <tbody>
          <tr
              v-for="request in temp_requests"
              :key="request.id"
              :class="requestTableStatusColor(request.request_status_id, request.date_expire48)"
              class="table-row"
          >
            <td v-if="is_fitter">
              <span v-if="request.is_repeated === 'True'" class="text-warning">
                <i class="fas fa-exclamation-triangle"></i>
              </span>
              <div v-if="request_statuses_list_show_edit.includes(request.request_status_id)">
                <edit-request-fitter-side-modal
                    :request_id="request.request_id"
                    :fitter_id="request.fitter_id"
                    :request_status_id="request.request_status_id"
                    :request_statuses="request_statuses"
                    :fitters_list="fitters_list"
                    :managers_list="managers_list"
                    :areas_streets_array="areas_streets_array"
                    :request_kinds_types_array="request_kinds_types_array"
                    @refresh-requests="refreshRequests"
                ></edit-request-fitter-side-modal>
              </div>
            </td>
            <td @click="goToRequestDetails(request.request_id)">{{ request.manager_name }}</td>
            <td @click="goToRequestDetails(request.request_id)">{{ formattedTimestamp(request.date_created) }}</td>
            <td @click="goToRequestDetails(request.request_id)">{{ request.client_name }}</td>
            <td @click="goToRequestDetails(request.request_id)">{{ request.street+" "+request.house+" "+request.flat }}</td>
            <td @click="goToRequestDetails(request.request_id)">{{ request.area }}</td>
            <td @click="goToRequestDetails(request.request_id)">
              <span v-if="request.is_repeated === 'True'" class="text-warning">
                <i class="fas fa-exclamation-triangle"></i>
              </span>
              {{ request.request_kind }}
            </td>
            <td @click="goToRequestDetails(request.request_id)">{{ request.request_status_name }}</td>
            <td @click="goToRequestDetails(request.request_id)">{{ request.manager_comment }}</td>
            <td @click="goToRequestDetails(request.request_id)">{{ request.fitter_name }}</td>
            <td @click="goToRequestDetails(request.request_id)">{{ request.fitter_comment}}</td>
            <td v-if="is_manager">
              <div v-if="request_statuses_list_show_edit.includes(request.request_status_id) ">
                <edit-request-manager-side-modal
                    :request_id="request.request_id"
                    :manager_id="request.manager_id"
                    :request_statuses="request_statuses"
                    :fitters_list="fitters_list"
                    :managers_list="managers_list"
                    :areas_streets_array="areas_streets_array"
                    :request_kinds_types_array="request_kinds_types_array"
                    @refresh-requests="refreshRequests"
                ></edit-request-manager-side-modal>
              </div>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
    <ul class="pagination justify-content-center pb-2">
      <li
          class="page-item"
          :class="temp_previous ? '' : 'disabled'"
          @click="goToPreviousPage"
      >
        <i class="fas fa-solid fa-arrow-left page-link"></i>
      </li>
      <li class="page-item">
        <span class="page-link">Page {{ currentPage }} of {{ Math.ceil(temp_count / page_size) }}</span>
      </li>
      <li
          class="page-item"
          :class="temp_next ? '' : 'disabled'"
          @click="goToNextPage"
      >
        <i class="fas fa-solid fa-arrow-right page-link"></i>
      </li>
    </ul>

  </div>
</template>

<style scoped>

.spinner-container {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(255, 255, 255, 0.2); /* Optional: Add a semi-transparent background */
  z-index: 9999; /* Ensure it's on top of other content */
}

[v-cloak] {
  display: none;
}

.spinner {
  width: 40px;
  height: 40px;
  position: relative;
  margin: auto;
}

.double-bounce1,
.double-bounce2 {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background-color: #007bff;
  opacity: 0.6;
  position: absolute;
  animation: bounce 2s infinite ease-in-out;
}

.double-bounce2 {
  animation-delay: -1s;
}

@keyframes bounce {
  0%, 100% {
    transform: scale(0);
  }
  50% {
    transform: scale(1);
  }
}

.table-fixed thead th {
  width: 150px; /* Example fixed width for columns */
  text-align: center; /* Center text for better readability */
}
.table-fixed tbody td {
  width: 150px; /* Ensure columns in body match headers */
  text-align: left;
}
.table-fixed tbody tr {
  height: 50px; /* Fixed row height */
}
.filter-menu{
  width: 1000px;
}
@media only screen and (max-width: 600px){
  .filter-menu{
    width: 350px;
  }
}
@media only screen and (max-width: 800px){
  .filter-menu{
    width: 650px;
  }
}
@media only screen and (max-width: 1200px){
  .filter-menu{
    width: 650px;
  }
}

</style>